import { convertStockData } from "components/utils/helper";
import toast from "react-hot-toast";
import { put, takeEvery } from "redux-saga/effects";
import { GENERAL_ERROR } from "../../static/static";
import { getBondsServ, getFavouritesServ, getHistoricDataServ, getMarketCapServ, getSearchTickerServ } from "../services/analysis.service";
import { analysisActions } from "../slice/analysis.slice";
import { GET_BONDS, GET_FAVOURITES, GET_HISTORIC_DATA, GET_MARKET_CAP, GET_SEARCH_TICKER } from "../types/analysis.types";


export function* getHistoricData(action) {
    try {
        const historicData = yield getHistoricDataServ(action?.payload);
        const parsedData = convertStockData(historicData);
        yield put(analysisActions.actions.setHistoricData(parsedData))
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}

export function* getMarketCap(action) {
    try {
        const marketCaps = yield getMarketCapServ();
        yield put(analysisActions.actions.setMarketCap(marketCaps));
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}


export function* getSearchTicker(action) {
    try {
        const searchTicker = yield getSearchTickerServ(action?.payload)
        yield put(analysisActions.actions.setSearchTicker(searchTicker));
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}

export function* getFavourites(action) {
    try {
        const favorites = yield getFavouritesServ(action?.payload);
        yield put(analysisActions.actions.setFavourites(favorites));
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}

export function* getBonds() {
    try {
        const results =yield getBondsServ()
        const parsedRes = results?.map((item, idx) => ({
            key: idx + 1,
            Issuer: item?.issuer,
            Series: item?.series_id,
            Type: item?.type,
            CPN: item?.CPN,
            Price: '$104.65',
            Bid: '$105.05',
            Ask: '$106.05',
        }))

        yield put(analysisActions.actions.setBonds(parsedRes));
    } catch (err) {
        console.log("err", err);
        toast.error(err?.response?.data?.message || GENERAL_ERROR);
    }
}

export function* watchAnalysisAsync() {
    yield takeEvery(GET_HISTORIC_DATA, getHistoricData);
    yield takeEvery(GET_MARKET_CAP, getMarketCap);
    yield takeEvery(GET_SEARCH_TICKER, getSearchTicker);
    yield takeEvery(GET_FAVOURITES, getFavourites);
    yield takeEvery(GET_BONDS, getBonds);
}